// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging';
import axios from '@/api'; // ✅ ဒီ import ရှိဖို့လိုတယ်

const firebaseConfig = {
  apiKey: "AIzaSyC0HY-Ge8hxjIL09Lxpwx1rAeI3CHgnyUQ",
  authDomain: "axefood-delivery.firebaseapp.com",
  projectId: "axefood-delivery",
  storageBucket: "axefood-delivery.firebasestorage.app",
  messagingSenderId: "870779106373",
  appId: "1:870779106373:web:9a2ba8dea3abc8b4f95f2c",
  measurementId: "G-G8BTGXRXCR"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

/**
 * FCM Token ရယူပြီး Server မှာ Update လုပ်မယ်
 * @param {number|string} userId - သုံးစွဲသူ ID
 * @param {boolean} forceRefresh - Token ကို အတင်းအကြပ် Refresh လုပ်မလား
 * @returns {Promise<string|null>} FCM Token သို့မဟုတ် null
 */
export const updateFCMToken = async (userId, forceRefresh = false) => {
  try {
    // Force refresh ဆိုရင် အရင် Token ကို ဖျက်ပါ
    if (forceRefresh) {
      await deleteToken(messaging);
      console.log('🔄 Old FCM token deleted');
    }
    
    const token = await getToken(messaging, {
      vapidKey: 'BPsFpCtyxykMZEpDJq2cMIf53kHt1nlEk_9Y3glFocjAMUoFlEiZZETGFz524AHa1gL2ytnKotNh4LZjtHA1Wy4'
    });
    
    if (token) {
      // Send to server with full URL
      await axios.post('/push/update-token', {
        user_id: userId,
        fcm_token: token,
        device_type: 'web',
        timestamp: Date.now()
      });
      
      // Store token in localStorage for comparison
      localStorage.setItem('fcm_token', token);
      localStorage.setItem('fcm_token_updated', Date.now().toString());
      
      console.log('✅ FCM Token updated:', token);
      return token;
    }
  } catch (error) {
    console.error('❌ Failed to update token:', error);
  }
  return null;
};

/**
 * Server နဲ့ Token ကို စစ်ဆေးခြင်း
 * @param {number|string} userId - သုံးစွဲသူ ID
 * @param {string} token - FCM Token
 * @returns {Promise<string|null>} အတည်ပြုပြီးသော Token
 */
export const validateTokenWithServer = async (userId, token) => {
  try {
    const response = await axios.post('/push/validate-token', {
      user_id: userId,
      fcm_token: token
    });
    
    if (response.data.needs_refresh) {
      return await updateFCMToken(userId, true);
    }
    
    return token;
  } catch (error) {
    console.error('Token validation failed:', error);
    return token;
  }
};

/**
 * Token သက်တမ်းစစ်ဆေးခြင်း
 * @param {number|string} userId - သုံးစွဲသူ ID
 * @returns {Promise<string|null>} အတည်ပြုပြီးသော Token
 */
export const checkTokenValidity = async (userId) => {
  const storedToken = localStorage.getItem('fcm_token');
  const lastUpdated = localStorage.getItem('fcm_token_updated');
  
  // Token မရှိရင် refresh
  if (!storedToken) {
    return await updateFCMToken(userId, true);
  }
  
  // Server ကိုပါ ထပ်စစ်မယ်
  const validToken = await validateTokenWithServer(userId, storedToken);
  
  // ၆ နာရီကျော်ရင် refresh
  if (!lastUpdated || (Date.now() - parseInt(lastUpdated)) > 6 * 60 * 60 * 1000) {
    return await updateFCMToken(userId, true);
  }
  
  return validToken;
};

/**
 * Foreground message listener
 * @param {Function} callback - Message ရောက်လာရင် ခေါ်မည့် function
 * @returns {Function} Unsubscribe function
 */
export const onMessageListener = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log('🔥 Foreground message received:', payload);
    callback(payload);
  });
};

// Export messaging and other functions
export { messaging, getToken, onMessage, deleteToken };